import React, { useEffect, useRef, useState } from "react";
import { ISearch } from "../../models/WareHouseModel";
import { useIntl } from "react-intl";
import { PaginationLength } from "../../../_metronic/partials/pagination/PaginationLength";
import { PaginationHeader } from "../../../_metronic/partials/pagination/PaginationHeader";
import { useHistory } from "react-router-dom";
import { Paginate } from "../../../_metronic/partials/pagination/Paginate";
import { PaginateModel } from "../../models/PaginateModel";
import queryString from "query-string";
import { formatPrice } from "../../selectors";
import { HeaderModel, ModalModel } from "../../models/CommonModel";
import { DEFAULT_PER_PAGE } from "../../constants/common";
import { AsyncSelect2 } from "../../../_metronic/partials/select/AsyncSelect2";
import { STORES_ENDPOINT } from "../../constants/endpoints";
import { exportReport, getReportList } from "./WareHouseCRUD";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import { download } from "../../modules/common/helper";
import { WareHouseModel } from "../../models/WarehouseReportModel";
import WareHouseTable from "./WareHouseTable";

const WareHouseReport = () => {
    const initSearch = {
        page: 1,
        per_page: DEFAULT_PER_PAGE,
    }
    const intl = useIntl();
    const history = useHistory();
    const [search, setSearch] = useState<ISearch>(initSearch)
    const [dataPaginate, setDataPaginate] = useState<PaginateModel<WareHouseModel>>();
    const [summary, setSummary] = useState<{
        total_consign_qty: number,
        total_sales_amount: number,
        total_warehouse_amount: number,
        total_debt: number
    }>();
    const fp = useRef<any>(null);
    const searchHistory = history.location.search;
    const [hideCols, setHideCols] = useState<string[]>([]);
    const [selectedStore, setSelectedStore] = useState(null);
    const [configModal, setConfigModal] = useState<ModalModel>({
        show: false,
        mode: 'add',
    });
    const parseParams = (params: ISearch) => {
        if (params.page) {
            params.page = +params.page
        }
        if (params.per_page) {
            params.per_page = +params.per_page
        }
        return params
    }

    const initParams: ISearch = parseParams(queryString.parse(searchHistory))

    useEffect(() => {
        document.title = 'Sento Supplier - Tình trạng tồn kho & Công nợ';
    })

    useEffect(() => {
        const params = { ...search, ...initParams }
        getListWareHouse({ ...params });
        setSearch({ ...params })
    }, [])


    const getListWareHouse = async (params: ISearch) => {
        const { data: resData } = await getReportList(params);
        setDataPaginate(resData.paginate_data);
        setSummary(resData.summary);
    }

    const handleExport = async (params: ISearch) => {
        const { data } = await exportReport(params);
        download(data, 'products');
    }

    const handlePageLengthChange = (e: any) => {
        getListWareHouse({ ...search, page: 1, per_page: +e.target.value })
    }

    const handlePageChange = (data: any) => {
        getListWareHouse({ ...search, page: data.selected + 1 })
    }

    const handleSearch = (e: any) => {
        e.preventDefault();
        getListWareHouse({ ...search, page: 1 })

    }

    const handleClearSearch = (e: any) => {
        e.preventDefault();
        
        if (fp.current?.flatpickr) {
            fp.current.flatpickr.clear();
        }
        getListWareHouse({ ...initSearch })
        setSelectedStore(null)
        setSearch({
            ...initSearch
        });
    }

    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            handleSearch(e);
        }
    }

    const header: HeaderModel[] = [
        {
            label: intl.formatMessage({ id: 'WAREHOUSE.PRODUCT_NAME' }),
            field: 'product_name',
            style: { maxWidth: "150px", minWidth: "150px", },
            sortable: true
        },
        {
            label: 'Tên cửa hàng',
            field: 'store_name',
            sortable: true
        },
        {
            label: 'Nhập/Xuất',
            field: 'action',
            sortable: false
        },
        {
            label: 'Đơn giá',
            field: 'price',
            style: { maxWidth: "80px", minWidth: "80px", },
            sortable: true
        },
        {
            label: 'VAT',
            field: 'vat',
            style: { maxWidth: "80px", minWidth: "80px", },
            sortable: true
        },
        {
            label: 'Doanh thu',
            field: 'amount',
            sortable: true
        },
        {
            label: 'Tổng tồn',
            field: 'total_remain',
            sortable: true
        }
    ]

    const handleSort = (sortBy: string, direction: 'asc' | 'desc' | 'none') => {
        const currentSearch = { ...search };
        const sortParams: ISearch = { ...currentSearch, sort_by: sortBy, sort_direction: direction };
        if (direction === 'none') {
            delete sortParams.sort_by;
            delete sortParams.sort_direction;
        }
        getListWareHouse({ ...sortParams });
    }

    const handleChangeVisCols = (e: any) => {
        let hiddenCols = [...hideCols];
        if (!e.target?.checked) {
            setHideCols([...hiddenCols, e.target.name])
        } else {
            setHideCols(hiddenCols.filter((item) => item !== e.target.name))
        }
    }

    return <div className="card">
        <div className="card-header py-4">
            <div className="col-md-12">
                <form onSubmit={handleSearch}>
                    <div className="row">
                        <div className='col-md-3 mb-2'>
                            <label className="form-label" htmlFor="name">Tên sản phẩm</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Tên sản phẩm"
                                name="name"
                                id="name"
                                autoComplete='nope'
                                value={search.name || ''}
                                onChange={(e) => {
                                    setSearch({ ...search, name: e.target.value })  
                                }}
                                onKeyDown={(e) => handleKeyDown(e)}
                            />
                        </div>
                        <div className='col-md-3 mb-2'>
                            <label className='form-label'>Cửa hàng</label>
                            <AsyncSelect2
                                sourceUrl={`${STORES_ENDPOINT}`}
                                defaultOptions
                                default
                                name='store_id'
                                value={selectedStore}
                                onChange={(selectedOption: any) => {
                                    setSearch({ ...search, store_id: selectedOption ? selectedOption.value : '' })
                                    setSelectedStore(selectedOption);
                                }}
                            />
                        </div>
                        <div className='col-md-3 mb-2'>
                            <label className="form-label">{intl.formatMessage({ id: 'COMMON.TIME' })}</label>
                            <Flatpickr
                                ref={fp}
                                onChange={(date) => {
                                    let startDate = moment(date[0]).format('YYYY-MM-DD');
                                    let endDate = moment(date[1]).format('YYYY-MM-DD');
                                    setSearch({ ...search, start_date: startDate, end_date: endDate });
                                }}
                                options={{
                                    mode: "range",
                                    dateFormat: 'd-m-Y',
                                    enableTime: false,
                                }}
                                className='form-control'
                                placeholder=''
                            />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className='d-flex'>
                            <label className='form-check form-check-sm form-check-custom form-check-solid ms-3'>
                                <input className='form-check-input'
                                    type='checkbox' name='has_warehouse'
                                    checked={search?.has_warehouse === 1}
                                    onChange={(e) => setSearch({ ...search, has_warehouse: e.target.checked ? 1 : 0 })}
                                />
                                <span className='form-check-label'>Tồn kho</span>
                            </label>
                            <label className='form-check form-check-sm form-check-custom form-check-solid ms-3'>
                                <input className='form-check-input'
                                    type='checkbox' name='has_sales'
                                    checked={search?.has_sales === 1}
                                    onChange={(e) => setSearch({ ...search, has_sales: e.target.checked ? 1 : 0 })}
                                />
                                <span className='form-check-label'>Chỉ hiển thị sản phẩm có doanh thu</span>
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        <div className='col-md-5 mb-2 d-flex'>
                            <button
                                className="col-auto btn btn-primary mt-2 me-2"
                                onClick={handleSearch}
                            >
                                <i className="bi bi bi-search fs-4"></i> {intl.formatMessage({ id: 'COMMON.SEARCH' })}
                            </button>
                            <button
                                className="col-auto btn btn-danger mt-2 me-2"
                                type="button"
                                onClick={handleClearSearch}
                            >
                                <i className="bi bi-eraser-fill fs-1"></i>
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        </div>
        <div className="card-body">
            <div className="justify-content-between align-items-center my-3 row">
                <div className='col-md-4'>
                    <PaginationHeader
                        from={dataPaginate?.meta?.from || 0} to={dataPaginate?.meta?.to || 0}
                        total={dataPaginate?.meta?.total || 0}
                    />
                </div>
                <div className='col-md-8 text-end btns-group p-0'>
                    <button type="button" className="btn btn-primary btn-sm mx-1 mb-1" onClick={() => handleExport(search)}>
                        <i className="bi bi bi-cloud-arrow-down-fill"></i> {intl.formatMessage({ id: 'COMMON.EXPORT' }, { name: '' })}
                    </button>
                </div>
                <div className='col-12 col-md-4'>
                    <h3>SL Ký gửi: <span className="text-bold">{formatPrice(summary?.total_consign_qty ?? 0)}</span></h3>
                </div>
                <div className='col-12 col-md-4'>
                    <h3>Đã bán: <span className="text-bold">{formatPrice(summary?.total_sales_amount ?? 0)} VNĐ</span></h3>
                </div>
                <div className='col-12 col-md-4'>
                    <h3>Còn tồn: <span className="text-bold">{formatPrice(summary?.total_warehouse_amount ?? 0)} VNĐ</span></h3>
                </div>
                <div className='col-12 col-md-4'>
                    <h3>Công nợ: <span className="text-bold">{formatPrice(summary?.total_debt ?? 0)} VNĐ</span></h3>
                </div>
                <div className='col-12 col-md-4'>
                </div>
            </div>
            <WareHouseTable
                data={dataPaginate?.data || []}
                openColConfig={() => setConfigModal({ ...configModal, show: true })}
                header={header}
                hideCols={hideCols}
                handleSort={handleSort}
            />
        </div>
        <div className="card-footer d-flex justify-content-between paginate-wrapper">
            <PaginationLength selected={search.per_page || DEFAULT_PER_PAGE} onChange={handlePageLengthChange} />
            <Paginate
                pageCount={dataPaginate?.meta?.last_page || 0}
                onPageChange={handlePageChange}
                forcePage={(search.page || 1) - 1}
            />
        </div>
        {/* <ConfigModal
            {...configModal}
            header={header}
            hideCols={hideCols}
            handleChangeVisCols={handleChangeVisCols}
            onClose={() => { setConfigModal({ ...configModal, show: false }) }}
        /> */}
    </div>
}
export default WareHouseReport;